

















































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { mapState, mapGetters } from 'vuex'
import FloorModel from '@/_models/FloorModel'
import FloorMapAdjust from '@/components/floor/partials/FloorMapAdjust.vue'

// Interface
import { IPageFilterModel } from '@/_interfaces'

// Shared
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import TablePagination from '@/components/shared/TablePagination.vue'

// Common
import NotFound from '@/components/common/NotFound.vue'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

import * as DownloadCsv from 'vue-json-csv'
import { Filter } from '@/_utils/filter'

@Component({
  components: {
    FloorMapAdjust,
    DownloadCsv,
    FilterDropdown,
    NotFound,
    TablePagination,
  },
  computed: {
    ...mapGetters('common', {
      fullThumbImageUrl: 'fullThumbImageUrl',
    }),
    ...mapGetters('floors', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('floors', {
      canDelete: 'canDelete',
    }),
  },
})
export default class FloorList extends mixins(TableSortMixin) {
  canEdit!: () => boolean
  canDelete!: () => boolean
  fullThumbImageUrl!: (filename: string) => any

  // data
  filterUtilTableSort: any = new Filter('filter_floor_list_table_sort')
  filterUtilPage: any = new Filter('filter_floorlist_page')
  pageFilters: IPageFilterModel = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'name',
    searchQuery: '',
  }
  numofPage: number = 1
  selected: FloorModel = new FloorModel()
  isFormModalActive: boolean = false
  isImportCsvModalActive: boolean = false
  isMapAdjustActive: boolean = false

  isNew: boolean = false
  uploadFile: any = null
  mapAdjustData: any = {}

  filedNameLUT: any = {
    _id: 'UUID',
    name: 'label.floor_name',
    building_name: 'label.building_name',
    // num_beacon: 'label.num_beacon',
    floor_sw_lat: 'label.floor_sw_lat',
    floor_sw_lon: 'label.floor_sw_lon',
    floor_ne_lat: 'label.floor_ne_lat',
    floor_ne_lon: 'label.floor_ne_lon',
    floor_angle: 'label.floor_angle',
    floor_map_zoom: 'label.floor_map_zoom',
    floor_opacity: 'label.floor_opacity',
  }

  // Import/Export csv setting
  csvFile: any = null
  csvFields: any = [
    '_id',
    'name',
    'building_name',
    // 'num_beacon',
    'floor_sw_lat',
    'floor_sw_lon',
    'floor_ne_lat',
    'floor_ne_lon',
    'floor_angle',
    'floor_map_zoom',
    'floor_opacity',
  ]

  // computed
  get floors(): FloorModel[] {
    const floors = this.$store.state.floors.all.items
    this.numofPage = Math.ceil(floors.length / this.pageFilters.perPage)

    return floors
  }

  get buildings(): string[] {
    const buildings: string[] = []
    for (const floor of this.floors) {
      if (buildings.indexOf(floor.building_name) === -1) {
        buildings.push(floor.building_name)
      }
    }

    return buildings
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isLoading(): boolean {
    return this.$store.state.floors.loading
  }

  get filteredData(): FloorModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.floors) {
      return []
    }

    return this.floors.filter((item: any): boolean => {
      return (
        String(item[targetField]).toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1 ||
        item._id === this.pageFilters.searchQuery // Can search by uuid
      )
    })
  }

  get filteredDataBuilding(): string[] {
    if (!this.buildings) {
      return []
    }

    return this.buildings.filter((name: string): boolean => {
      return String(name).toLowerCase().indexOf(this.selected.building_name.toLowerCase()) !== -1
    })
  }

  @Watch('isFormModalActive')
  watchFormModalActive(): void {
    this.uploadFile = null
  }

  @Watch('uploadFile')
  uploadFileChanged(): void {
    if (this.uploadFile) {
      this.$store.dispatch('floors/uploadFile', this.uploadFile).then(resp => {
        this.selected.floor_file = resp.file_url_org_url || resp.file_url_org
        this.uploadFile = null
      })
    }
  }

  handleSelecteBuilding(buildingName: string): void {
    this.selected.building_name = buildingName
  }

  handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
    this.isNew = false
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new FloorModel()
    this.isNew = true
  }

  handleOpenModalImportCSV(): void {
    this.isImportCsvModalActive = true
  }

  handleCancelImportModal(): void {
    this.isImportCsvModalActive = false
    this.csvFile = null
  }

  handleOpenModelAdjustMap(): void {
    this.mapAdjustData.name = this.selected.name
    // Default location is Tokyo Japan.
    this.mapAdjustData._id = this.selected._id
    this.mapAdjustData.floor_sw_lat = this.selected.floor_sw_lat || 35.65577696083861
    this.mapAdjustData.floor_sw_lon = this.selected.floor_sw_lon || 139.8335337638855
    this.mapAdjustData.floor_ne_lat = this.selected.floor_ne_lat || 35.65790646200456
    this.mapAdjustData.floor_ne_lon = this.selected.floor_ne_lon || 139.83752589941025
    this.mapAdjustData.floor_angle = this.selected.floor_angle || 0
    this.mapAdjustData.floor_file = this.selected.floor_file || ''
    this.mapAdjustData.floor_map_zoom = this.selected.floor_map_zoom || 18
    this.mapAdjustData.floor_opacity = this.selected.floor_opacity || 50
    this.isMapAdjustActive = true
  }

  async handleApplyChange(): Promise<void> {
    this.doApplyChange()
  }

  async handleImportCSV(): Promise<void> {
    this.$store.dispatch('floors/importCSV', this.csvFile).then(resp => {
      this.handleCancelImportModal()
      this.$buefy.toast.open(this.$t('messages.save_success') as string)
    })
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  async doApplyChange(): Promise<void> {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return false
      }
      if (this.isNew) {
        // Add one
        this.$store.dispatch('floors/addOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store.dispatch('floors/updateOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.update_success') as string)
        })
      }
    })
  }

  confirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.$store.dispatch('floors/hasRefs', this.selected).then(result => {
          if (result.has_reference) {
            this.confirmForceDelete(data)
          } else {
            this.processDelete(data)
          }
        })
      },
    })
  }

  confirmForceDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.has_refs_data_are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      },
    })
  }

  processDelete(data): void {
    this.selected = data
    const index = this.floors.indexOf(this.selected)
    this.$store.dispatch('floors/deleteOne', this.selected).then(() => {
      this.selected = new FloorModel()
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  mapAjustDone(data): void {
    this.selected.floor_sw_lat = data.floor_sw_lat
    this.selected.floor_sw_lon = data.floor_sw_lon
    this.selected.floor_ne_lat = data.floor_ne_lat
    this.selected.floor_ne_lon = data.floor_ne_lon
    this.selected.floor_angle = data.floor_angle
    this.selected.floor_map_zoom = data.floor_map_zoom
    this.selected.floor_opacity = data.floor_opacity
    this.isMapAdjustActive = false
  }

  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.$store.dispatch('floors/getAll')
  }
}
